import {
  useMutation,
  useQueryClient,
} from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { toast } from "@/hooks/use-toast"
import i18n from "@/i18n"
interface UpdateWebhookParams {
  webhookId: string
  data: {
    description: string
    url: string
    events: string[]
    maxRetry: number
    blockManyErrors: boolean
    secretKey?: string
    active: boolean
  }
}
export const updateWebhook = async ({
  webhookId,
  data,
}: UpdateWebhookParams) => {
  const url = `${ENDPOINTS.WEBHOOKS}/${webhookId}`
  const response = await api.put<WebhookConfigurationType>(
    url,
    data
  )
  return response.data
}
export const useUpdateWebhook = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateWebhook,
    onSuccess: (_, variables) => {
      toast({
        title: i18n.t("webhooks.updateSuccess"),
        variant: "success",
      })
      queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.WEBHOOKS],
      })
      queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.WEBHOOKS, variables.webhookId],
      })
    },
    onError: () => {
      toast({
        title: i18n.t("webhooks.updateError"),
        variant: "destructive",
      })
    },
  })
}
export default useUpdateWebhook
